module.exports = {"350526100":"浔中镇","350526101":"龙浔镇","350526102":"三班镇","350526103":"龙门滩镇","350526104":"雷峰镇","350526105":"南埕镇","350526106":"水口镇","350526107":"赤水镇","350526108":"上涌镇","350526109":"葛坑镇","350526110":"盖德镇","350526111":"美湖镇","350526200":"杨梅乡","350526202":"汤头乡","350526204":"桂阳乡","350526206":"国宝乡","350526208":"大铭乡","350526209":"春美乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350526.json
// module id = 1315
// module chunks = 0